import {
  Component,
  ViewChild,
  OnInit,
  TemplateRef,
  ElementRef
} from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

import { LoginService } from "./../core/services/login.service";
import { NormalizeMsisdnService } from "./../core/services/normalize-msisdn.service";

import { Globals } from "./../core/global";
import { EventsService } from '../core/services/events.service';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  loader = false;

  heMsisdn = "";
  msisdn: any;
  pin: any;
  errorMessage = "";
  pageLogin = false;
  password: any;
  subProducts: any;
  tcen = false;
  tcar = false;
  lang: any;

  pinSent: boolean;
  invalidMsisdn: boolean;
  invalidPin: boolean;
  invalidToken: boolean;
  invalidApi: boolean;
  tooManyPin: boolean;
  submitedPin: boolean;

  responsePin: any;
  responseLogin: any;

  constructor(
    public loginService: LoginService,
    private global: Globals,
    public router: Router,
    private location: Location,
    private normalizeService: NormalizeMsisdnService,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.events.eventStart({ eventType: 'MSISDN_PAGE_ACCESS', triggerType: 'access' });

    this.lang = localStorage.getItem('lang');
    if (localStorage.getItem("msisdn") != null) {
      this.router.navigate(['/start-game']);
    }
  }

  ngAfterViewInit() {
    this.events.eventStart({ eventType: 'MSISDN_PAGE_LOADED', triggerType: 'access' });
  }

  askPin(msisdn) {
    this.events.eventStart({ eventType: 'MSISDN_SUBMITTED', triggerType: 'submit' });
    this.loader = true;
    
    if (msisdn != "") {
      this.normalizeService.getMsisdn(msisdn).subscribe(msisdn => {
        const nMsisdn = msisdn["responseData"].normalizedMsisdn;

        this.loginService.askPin(nMsisdn).subscribe(respPin => {
          
          if (respPin["responseCode"] === "200") {
            this.events.eventStart({ eventType: 'MSISDN_SUCCESS', triggerType: 'success', responseData: JSON.stringify(respPin) });
            this.pinSent = true;

            this.invalidMsisdn = false;
            this.invalidPin = false;
          } else if (respPin["responseCode"] === "400") {
            this.events.eventStart({ eventType: 'MSISDN_ERROR', triggerType: 'error', responseData: JSON.stringify(respPin) });
            this.invalidToken = true;
          } else if (respPin["responseCode"] === "500") {
            this.events.eventStart({ eventType: 'MSISDN_ERROR', triggerType: 'error', responseData: JSON.stringify(respPin) });
            this.invalidMsisdn = true;
          }
          this.loader = false;
        });
      });
    } else {
      this.events.eventStart({ eventType: 'MSISDN_EMPTY', triggerType: 'error' });
      this.loader = false;
      this.invalidMsisdn = true;
    }
    
  }

  validatePin(msisdn, pin) {
    this.events.eventStart({ eventType: 'PIN_SUBMITED', triggerType: 'submit' });

    this.loader = true;
    if (msisdn != "" && pin != "") {
      this.normalizeService.getMsisdn(msisdn).subscribe(msisdn => {
        const nMsisdn = msisdn["responseData"].normalizedMsisdn;

        this.loginService.validatePin(nMsisdn, pin).subscribe(respLogin => {
          if (respLogin["responseCode"] === "200") {
            this.events.eventStart({ eventType: 'PIN_SUBMIT_SUCCESS', triggerType: 'success', responseData: JSON.stringify(respLogin) });

            localStorage.setItem("msisdn", btoa(nMsisdn));
            localStorage.setItem("token", respLogin["responseData"].token);

            this.router.navigate(["/onboarding"]);
          } else if (respLogin["responseCode"] === "400") {
            this.events.eventStart({ eventType: 'PIN_SUBMIT_ERROR', triggerType: 'error', responseData: JSON.stringify(respLogin) });
            this.invalidApi = true;
          } else if (respLogin["responseCode"] === "401") {
            this.events.eventStart({ eventType: 'PIN_SUBMIT_ERROR', triggerType: 'error', responseData: JSON.stringify(respLogin) });
            this.invalidToken = true;
          } else if (respLogin["responseCode"] === "500") {
            this.events.eventStart({ eventType: 'PIN_SUBMIT_ERROR', triggerType: 'error', responseData: JSON.stringify(respLogin) });
            this.invalidApi = true;
          }
          this.loader = false;
        });
      });
    } else {
      this.events.eventStart({ eventType: 'PIN_EMPTY', triggerType: 'error' });
      this.invalidApi = true;
      this.loader = false;
    }
    
  }

  recordMsisdn(event) {
    this.msisdn = (<HTMLInputElement>event.target).value;
  }

  recordPin(event) {
    this.pin = (<HTMLInputElement>event.target).value;
  }

  closePopup(index = null) {
    this.invalidPin = false;
    this.invalidMsisdn = false;
    this.pinSent = false;
    this.invalidApi = false;
    this.invalidToken = false;
    this.loader = false;
    this.tcen = false;
    this.tcar = false;
  }

  goBack() {
    this.location.back();
  }
}
